const locale = {
  BANNER_TEXT: 'Перегляд адміністратора лише для читання: {{company}}',
  BANNER_TEXT_NO_COMPANY: 'Перегляд адміністратора лише для читання',
  EXIT: 'Вийти',
  SESSION_EXPIRED: 'Сесію перегляду лише для читання завершено',
};

export default locale;
